export default __webpack_public_path__ + "static/media/modelB-cap.0855d3dc.png";